<template>
  <div class="pa-5 w-100">
    <p class="text-h6 primary--text">
      Você confirma a atribuição de titularidade a este ingresso?
    </p>

    <hr>

    <p class="mt-5">
      <strong>Informações do ingresso:</strong>
    </p>

    <p class="mb-1">
      <strong>Nome:</strong> {{ dadosNovaTitularidade.name }}
    </p>

    <p class="mb-1">
      <strong>CPF:</strong> {{ dadosNovaTitularidade.cnpjCpf }}
    </p>

    <p class="mb-1">
      <strong>E-mail:</strong> {{ dadosNovaTitularidade.email }}
    </p>

    <p class="mb-1">
      <strong>Telefone:</strong> {{ dadosNovaTitularidade.phone }}
    </p>

    <p class="mb-1">
      <strong>Cargo:</strong> {{ dadosNovaTitularidade.position }}
    </p>

    <p class="mb-5">
      <strong>Empresa:</strong> {{ dadosNovaTitularidade.company }}
    </p>

    <hr>

    <div
      class="text-right pt-5"
      :class="{'d-flex flex-row-reverse': desktop}"
    >
      <v-btn
        :loading="loading"
        color="success"
        :block="mobile"
        @click="salvarTitularidade"
      >
        Sim, atribuir
      </v-btn>
      <v-btn
        color="red"
        text
        :block="mobile"
        @click="$emit('cancel')"
      >
        <v-icon v-if="mobile">
          mdi-chevron-left
        </v-icon>
        Não
      </v-btn>
    </div>
  </div>
</template>

<script>
import ApiIngressos from '@/api/ingressos';

export default {
  name: 'TitularidadeIngressoConfirmacao',

  props: {
    dadosNovaTitularidade: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    loading: false,
  }),

  methods: {
    salvarTitularidade() {
      this.loading = true;

      ApiIngressos.salvarTitularidade({
        ...this.dadosNovaTitularidade,
        phone: this.dadosNovaTitularidade.phone ? `+55 ${this.dadosNovaTitularidade.phone}` : '',
      })
        .then(() => this.$emit('saved'))
        .catch((error) => {
          let mensagem = '';

          if (error.response && error.response.data && error.response.erros) {
            [mensagem] = error.response.data.errors;
          }

          this.$emit('error', mensagem);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
